<template>
  <div class="publish-repeat-list">
    <div class="publish-repeat-list__items">
      <div
        v-for="(item, index) in items"
        :key="itemKey(item, index)"
        class="publish-repeat-list__item"
      >
        <div class="publish-repeat-list__header">
          <span>{{ mobileSharedText(itemLabel) }} {{ index + 1 }}</span>
          <!-- 删除{name} -->
          <button
            type="button"
            class="publish-repeat-list__delete"
            :aria-label="
              $t('attachmentUi.deleteNamedItem', {
                name: mobileSharedText(itemLabel),
              })
            "
            @click="$emit('remove', index)"
          >
            <van-icon name="delete-o" />
          </button>
        </div>
        <slot name="item" :item="item" :index="index" />
      </div>
    </div>
    <PublishButton
      native-type="button"
      block
      tone="secondary"
      class="publish-repeat-list__add"
      @click="$emit('add')"
    >
      <van-icon name="plus" />
      {{ mobileSharedText(addText) }}
    </PublishButton>
  </div>
</template>

<script>
import { mobileSharedText } from "@/i18n/common/index.js";
import PublishButton from "./PublishButton.vue";

export default {
  name: "PublishRepeatList",
  components: { PublishButton },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    itemLabel: {
      type: String,
      default: "项目",
    },
    addText: {
      type: String,
      default: "添加",
    },
    itemKeyField: {
      type: String,
      default: "id",
    },
  },
  methods: {
    mobileSharedText,
    itemKey(item, index) {
      return item && item[this.itemKeyField] != null
        ? item[this.itemKeyField]
        : index;
    },
  },
};
</script>

<style lang="less" scoped>
@import "./tokens.less";

.publish-repeat-list__items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.publish-repeat-list__item {
  overflow: hidden;
  padding: 10px;
  background: #f8fafc;
  border: 1px solid #edf0f5;
  border-radius: 8px;
}

.publish-repeat-list__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: @publish-text-regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.publish-repeat-list__delete {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: @publish-text-secondary;
  font-size: 18px;
  background: transparent;
  border: 0;
  border-radius: 4px;
}

.publish-repeat-list__delete:active {
  color: @publish-danger;
  background: #f2f3f5;
}

.publish-repeat-list__add {
  margin-top: 8px;

  /deep/ .van-button__text {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
  }
}
</style>
